import { Component, computed, inject } from '@angular/core';
import { FloatingDialogOutletComponent } from '@pxl/ui';
import { ChatbotDialogComponent } from '../chatbot-dialog/chatbot-dialog.component';
import { ChatbotStore } from '../chatbot.store';

@Component({
    selector: 'pxl-chatbot-outlet',
    standalone: true,
    imports: [ChatbotDialogComponent, FloatingDialogOutletComponent],
    templateUrl: './chatbot-outlet.component.html',
})
export class ChatbotOutletComponent {
    protected readonly store = inject(ChatbotStore);
    protected readonly showBackdrop = computed(() => this.store.isOpen() && this.store.fullScreen());
}
